var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center align-items-center" },
    [
      _c(
        "a",
        {
          staticClass: "btn w-100",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.showModal()
            }
          }
        },
        [_vm._v(_vm._s(_vm.button))]
      ),
      _vm._v(" "),
      _vm.modalVisible
        ? _c(
            "cat-uxo-modal",
            {
              on: {
                close: function($event) {
                  return _vm.hideModal()
                }
              }
            },
            [
              _vm.errors
                ? _c(
                    "div",
                    { staticClass: "errors mb-2" },
                    [
                      _vm._l(_vm.errors, function(item) {
                        return [
                          Array.isArray(item)
                            ? _vm._l(item, function(error) {
                                return _c("div", { staticClass: "error" }, [
                                  _vm._v(_vm._s(error))
                                ])
                              })
                            : [
                                _c("div", { staticClass: "error" }, [
                                  _vm._v(_vm._s(item))
                                ])
                              ]
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "h2",
                {
                  staticClass: "text-center t-orange",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _vm._v(
                    "You’re contributing to " +
                      _vm._s(_vm.contributionModel.name)
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass:
                    "form form-register d-flex flex-column justify-content-center",
                  attrs: { slot: "body", method: "POST" },
                  slot: "body"
                },
                [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-full" }, [
                      _c(
                        "div",
                        {
                          staticClass: "field",
                          class: {
                            "has-error": _vm.$v.form.contribution_text.$error
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label mb-1",
                              attrs: { for: "contributionText" }
                            },
                            [_vm._v("Add your text contribution below*")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "control" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.$v.form.contribution_text.$model,
                                  expression:
                                    "$v.form.contribution_text.$model",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "textarea",
                              attrs: {
                                id: "contributionText",
                                name: "contribution_text"
                              },
                              domProps: {
                                value: _vm.$v.form.contribution_text.$model
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.$v.form.contribution_text,
                                    "$model",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.$v.$dirty && _vm.$v.form.contribution_text.$error
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getErrorMessage(
                                        _vm.$v.form.contribution_text
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-full" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label mb-1" }, [
                          _vm._v("Upload your images and files here")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field position-relative mb-4" },
                        [
                          _c("div", { staticClass: "upload" }, [
                            _c("div", { staticClass: "control" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "upload__select p1 t-dark-grey lh-reset bg-white px-1 px-sm-2 py-2"
                                },
                                [
                                  _c(
                                    "file-upload",
                                    {
                                      ref: "upload",
                                      staticClass: "file-upload",
                                      attrs: {
                                        id: "fileUpload",
                                        extensions: "gif,jpg,jpeg,png,webp,pdf",
                                        accept:
                                          "image/png,image/gif,image/jpeg,image/webp,application/pdf,text/csv,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        multiple: true,
                                        size: 1024 * 1024 * 10
                                      },
                                      on: {
                                        "input-filter": _vm.inputFilter,
                                        "input-file": _vm.inputFile
                                      },
                                      model: {
                                        value: _vm.files,
                                        callback: function($$v) {
                                          _vm.files = $$v
                                        },
                                        expression: "files"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        Choose files\n                                    "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "control" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-upload",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.$refs.upload.$children[0].$el.click()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                    Choose Files\n                                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.files.length
                              ? _c(
                                  "div",
                                  { staticClass: "upload__files mt-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "t-navy lh-lg mb-1" },
                                      [_vm._v("Files to upload")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "files t-navy rows" },
                                      [
                                        _vm._l(_vm.files, function(
                                          file,
                                          index
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: file.id,
                                              staticClass:
                                                "file odd row px-1 px-sm-3 py-12px t-navy w-100"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex w-100" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "column p-0 file__name fs-18 py-12px"
                                                    },
                                                    [_vm._v(_vm._s(file.name))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "column p-0 file__btn text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "scroll-to",
                                                              rawName:
                                                                "v-scroll-to",
                                                              value: {
                                                                el:
                                                                  "#confirmDelete",
                                                                offset: -120
                                                              },
                                                              expression:
                                                                "{el: '#confirmDelete',offset: -120}"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "btn btn-ghost btn-small w-100 p-1",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.confirmDelete(
                                                                file,
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Delete")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _vm.showConfirm
                                          ? _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "file row px-1 px-sm-3 py-12px t-navy w-100"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex w-100 align-items-center",
                                                    attrs: {
                                                      id: "confirmDelete"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column is-8 font-weight-light p-0 py-12px"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Are you sure you want to delete "
                                                        ),
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.fileToDelete
                                                                .name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "?\n                                            "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column p-0 buttons text-right"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "btn btn-ghost btn-small btn-small--navy w-100 p-1 mr-sm-2 mb-2 mb-sm-0",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.keepFile()
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Keep")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "btn btn-ghost btn-small w-100 p-1",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.deleteFile()
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Delete")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "field mx-auto" },
                    [
                      !_vm.loading
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-form",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.submit($event)
                                }
                              }
                            },
                            [_vm._v("Add your contribution")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loading
                        ? _c("pulse-loader", {
                            attrs: {
                              loading: true,
                              color: "#E57722",
                              size: "20px"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ad8cf88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ad8cf88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/Contribute.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7ad8cf88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/Contribute.vue
// module chunks = 0 1